import { render } from "./GMapRegionBorder.vue?vue&type=template&id=f072539e"
import script from "./GMapRegionBorder.vue?vue&type=script&lang=js"
export * from "./GMapRegionBorder.vue?vue&type=script&lang=js"

import "./GMapRegionBorder.vue?vue&type=style&index=0&id=f072539e&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__